import css from "styled-jsx/css";
import Colors from "styles/colors";
import {
  SECTION_ITEM_HEIGHT,
  SECTION_ITEM_WIDTH,
  SECTION_ITEM_HORIZONTAL_MARGIN,
  SECTION_ITEM_SMALL_HORIZONTAL_MARGIN,
  SECTION_MARGIN_BETWEEN_COLUMNS,
  SECTION_SMALL_MARGIN_BETWEEN_COLUMNS
} from "../constants";
import { HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH } from "/constants/vp-sizes";
import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";

const SECTION_ITEM_HEIGHT_PX = `${SECTION_ITEM_HEIGHT}px`;
const SECTION_ITEM_WIDTH_PX = `${SECTION_ITEM_WIDTH}px`;

const SECTION_ITEM_HORIZONTAL_MARGIN_PX = `${SECTION_ITEM_HORIZONTAL_MARGIN}px`;
const SECTION_ITEM_SMALL_HORIZONTAL_MARGIN_PX = `${SECTION_ITEM_SMALL_HORIZONTAL_MARGIN}px`;

const SECTION_MARGIN_BETWEEN_COLUMNS_PX = `${SECTION_MARGIN_BETWEEN_COLUMNS}px`;
const SECTION_SMALL_MARGIN_BETWEEN_COLUMNS_PX = `${SECTION_SMALL_MARGIN_BETWEEN_COLUMNS}px`;

export const componentStyles = css.global`
  .header-menu-section-component {
    height: 100%;

    .header-menu-section-title {
      font-weight: 700;
      font-size: 0.875rem;
    }
    .header-menu-section-items-wrapper {
      margin: 20px 0;

      display: grid;
      grid-auto-flow: column;
      grid-template-rows: repeat(var(--max-number-of-items-in-column), auto);

      .header-menu-section-item-component-wrapper {
        width: ${SECTION_ITEM_WIDTH_PX};
        height: ${SECTION_ITEM_HEIGHT_PX};
        margin-right: ${SECTION_ITEM_HORIZONTAL_MARGIN_PX};
        padding: 16px 8px;

        &:nth-child(n + 4):not(.product):not(.base):not(.use-case):not(.feature):not(.resource) {
          margin-left: ${SECTION_MARGIN_BETWEEN_COLUMNS_PX};
        }

        &:hover {
          background-color: var(--hover-background-color);
        }

        &.outline {
          border-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
        }
      }
    }

    .header-menu-see-more-wrapper {
      margin-bottom: 16px;

      .secondary-button {
        .secondary-button-text {
          font-size: 0.8125rem;
        }
      }
    }
  }

  @media (max-width: ${HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH}) {
    .header-menu-section-component {
      .header-menu-section-items-wrapper {
        .header-menu-section-item-component-wrapper {
          margin-right: ${SECTION_ITEM_SMALL_HORIZONTAL_MARGIN_PX};

          &:nth-child(n + 4) {
            margin-left: ${SECTION_SMALL_MARGIN_BETWEEN_COLUMNS_PX};
          }
        }
      }
    }
  }
`;
